document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});


(function () {
  const currentUrl = window.location.href;

  document.querySelectorAll("a.yv-product-img").forEach((element) => {
    element.addEventListener('click', (e) => {

      //var carousel_id = "";
      //document.querySelectorAll("div.yv-collection-product-grid yv-tabbed-collection-filter-items product-grid-carousel flickity-enabled is-draggable").forEach((element) => {
      //    var id = e.currentTarget.getAttribute('id');
      //    console.log("carousel_id: " + carousel_id);
      //});

      var id = e.currentTarget.getAttribute('data-product-id');
      gtag('event', 'screen_view', {
        'app_name': id,
        'screen_name': currentUrl
      });
      console.log("ID cliccato: " + id);
      console.log("Pagina corrente: " + currentUrl);
    });
  });
})();

  

  


function showTooltip() {
    let visibility = document.getElementById('tooltip').style.visibility;
    if ( visibility == "hidden" ) {
    document.getElementById("tooltip").style.visibility = "visible";
    } else {
    document.getElementById("tooltip").style.visibility = "hidden";
    };
  };

$(document).ready(function() {
    $("scalapay-widget").css("all", "");
    $("scalapay-widget").css("font-family", "greycliff-cfregular");
    $("scalapay-widget").css("font-size", "12px");
    $("scalapay-widget").css("text-align", "center"); 
    $("scalapay-widget").css("margin-top", "20px"); 
    $("scalapay-widget").css("background", "#fff");
    $("sscalapay-widget").css("padding-top", "3px"); 
    $("scalapay-widget").css("border-radius", "8px");
});

function closeCookiePopUp() {
  var close  = document.getElementById("shopify-pc__banner");
  close.innerHTML = "<button id='shopify-pc__banner__btn-decline' class='shopify-pc__banner__btn-decline cookie-close' type='button'>[X]</button>"; 
}

function click2copy() {
  var copyText = "EXTRA5%";
  navigator.clipboard.writeText(copyText);
  var tooltip = document.getElementById("myTooltip");
  tooltip.innerHTML = "Copiato: " + copyText;
}

function outC2C() {
  var tooltip = document.getElementById("c2cTooltip");
  tooltip.innerHTML = "Copia nel blocco note";
}

// CHANGES THE FONT COLOR WHEN HOVERING WHITE BUTTONS IN SLIDER AND COLLAGE COMPONENTS
document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.getElementsByClassName('button');
    const buttonBefore = document.querySelector('.button:before');

    Array.from(buttons).forEach(button => {
        button.addEventListener('mouseenter', () => {
            const beforeBgColor = window.getComputedStyle(button).color;
            const bgColor = window.getComputedStyle(button).backgroundColor;
          console.log("Colore di sfondo: ", bgColor);
          console.log("Colore di sfondo before: ", beforeBgColor);
            const oppositeColor = getOppositeColor(bgColor);
          console.log("Colore opposto: ", oppositeColor);
            button.style.color = oppositeColor;
          function getOppositeColor(rgb) {
        // Extract the RGB components
        console.log("Colore di sfondo before: ", beforeBgColor);
        const color = rgb.match(/\d+/g).map(Number);
        const r = color[0];
        const g = color[1];
        const b = color[2];

        // Calculate the opposite color
      if ( beforeBgColor == "rgb(255, 255, 255)") {
        var oppositeR = 57;
        var oppositeG = 10;
        var oppositeB = 10;
      } else {
        var oppositeR = 255;
        var oppositeG = 255;
        var oppositeB = 255;
      }
        

        return `rgb(${oppositeR}, ${oppositeG}, ${oppositeB})`;
    }
        });

        button.addEventListener('mouseleave', () => {
            button.style.color = ''; // Reset to original color
        });
      
    });

    
});